var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 3.75V7.5H30V18.75H24.375C19.2188 18.75 15 22.9688 15 28.125V37.8516C12.832 38.6279 11.25 40.6934 11.25 43.125C11.25 46.2158 13.7842 48.75 16.875 48.75C19.3066 48.75 21.3721 47.168 22.1484 45H45V41.25H22.1484C21.5771 39.6826 20.332 38.4229 18.75 37.8516V28.125C18.75 24.9902 21.2402 22.5 24.375 22.5H30V33.75H45V7.5H41.25V3.75H33.75ZM16.875 48.75H11.25V52.5H48.75V48.75H16.875ZM33.75 11.25H41.25V30H33.75V11.25ZM16.875 41.25C17.9297 41.25 18.75 42.0703 18.75 43.125C18.75 44.1797 17.9297 45 16.875 45C15.8203 45 15 44.1797 15 43.125C15 42.0703 15.8203 41.25 16.875 41.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI10);
export default __webpack_public_path__ + "static/media/i10.11c17125c20ee47fbeb0bddb979f695f.svg";
export { ForwardRef as ReactComponent };